// src/redux/inventoryunitSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_inventoryunit,
  add_inventoryunit,
  update_inventoryunit,
  delete_inventoryunit,
  get_inventoryunit_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  inventoryunit: [],
  inventoryunitlist:[],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description: "",
  },
};

// Async Thunks for API Calls
export const fetchinventoryunitList = createAsyncThunk(
    'inventoryunit/fetchinventoryunitlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_inventoryunit_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchinventoryunit = createAsyncThunk(
  "inventoryunit/fetchinventoryunit",
  async ({ page, page_size,school_id,search, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_inventoryunit(page, page_size,school_id,search,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createinventoryunit = createAsyncThunk(
  "inventoryunit/createinventoryunit",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_inventoryunit(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateinventoryunit = createAsyncThunk(
  "inventoryunit/updateinventoryunit",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_inventoryunit(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteinventoryunit = createAsyncThunk(
  "inventoryunit/deleteinventoryunit",
  async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_inventoryunit({ ids }, school_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// inventoryunit Slice
const inventoryunitSlice = createSlice({
  name: 'inventoryunits',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,description} = action.payload;
      state.formData = { id, name,description};
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description: "",
      };
    },
    setinventoryunit(state, action) {
      state.inventoryunit = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
 
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchinventoryunitList.fulfilled, (state, action) => {
        state.inventoryunitlist = action.payload.data;
      })
      .addCase(fetchinventoryunitList.rejected, (state, action) => {
        state.inventoryunitlist = [];
      })
     
       // Fetch inventoryunit
       .addCase(fetchinventoryunit.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchinventoryunit.fulfilled, (state, action) => {
        state.loading = false;
        state.inventoryunit = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchinventoryunit.rejected, (state, action) => {
        state.loading = false;
        state.inventoryunit = [];
        state.error = action.payload;
      })

      // Add inventoryunit
      .addCase(createinventoryunit.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createinventoryunit.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createinventoryunit.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update inventoryunit
      .addCase(updateinventoryunit.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateinventoryunit.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateinventoryunit.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete inventoryunit
      .addCase(deleteinventoryunit.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteinventoryunit.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteinventoryunit.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setinventoryunit,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = inventoryunitSlice.actions;
export default inventoryunitSlice.reducer;
